/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaMintedRequest } from '../../models/get-gacha-minted-request';
import { GetGachaMintedResponse } from '../../models/get-gacha-minted-response';

export interface GachaServiceGetGachaMinted$Params {
      body: GetGachaMintedRequest
}

export function gachaServiceGetGachaMinted(http: HttpClient, rootUrl: string, params: GachaServiceGetGachaMinted$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaMintedResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGachaMinted.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaMintedResponse>;
    })
  );
}

gachaServiceGetGachaMinted.PATH = '/api/v3/gateway/gacha/minted';
